// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { CreateRecurringDefinitionRequest } from './create-recurring-definition-request';

/** See com.rev360.pms.api.controller.schedule.scheduleitem.CreateOfficeClosedRequest */
/* istanbul ignore next */
@GandalfModel
export class CreateOfficeClosedRequest extends GandalfModelBase {

	@GandalfValidator({ sizeString: { message: 'Reason cannot be longer than 4000 characters', minLength: 0, maxLength: 4000 } })
	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: Number })
	displayColor!: number | null;

	@GandalfValidator({ notNull: { message: 'End Time is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	endDate!: Date;

	@GandalfValidator({ notNull: { message: 'Location must be selected' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationId!: number;

	@GandalfProperty({ designType: CreateRecurringDefinitionRequest })
	recurringDefinition!: CreateRecurringDefinitionRequest | null;

	@GandalfValidator({ notNull: { message: 'Start Time is required' } })
	@GandalfProperty({ designType: Date, isRequired: true })
	startDate!: Date;

}
